import { Alert, AlertDescription } from "@/components/ui/alert";

import { monthLabel } from "../../format";

/** Quick explainer above the dashboard — surfaces the auto-renewal + first-
 *  of-month proration mechanic so KPIs aren't read in a vacuum. */
export function DataCadenceBanner({
  currentMonth,
  latestClosed,
}: {
  currentMonth: string | null | undefined;
  latestClosed: string | null | undefined;
}) {
  if (!currentMonth) return null;
  const m1 = shiftYm(currentMonth, 1);
  const m2 = shiftYm(currentMonth, 2);
  return (
    <Alert>
      <AlertDescription className="text-xs">
        <strong>Data cadence.</strong> Contracts auto-renew unless the customer
        gives 30-day notice, and we prorate first-month billing so every
        customer's renewal lands on the 1st of the month. That means{" "}
        <b>{monthLabel(m1 + "-01")}</b> renewals are committed today;{" "}
        <b>{monthLabel(m2 + "-01")}</b> is firming up now (CSMs pick until the
        end of <b>{monthLabel(currentMonth + "-01")}</b>). Most-recent closed
        billing month: <b>{latestClosed ? monthLabel(latestClosed + "-01") : "—"}</b>.
      </AlertDescription>
    </Alert>
  );
}

function shiftYm(ym: string, months: number): string {
  const parts = ym.split("-");
  const y = Number(parts[0] ?? 0);
  const m = Number(parts[1] ?? 1);
  const total = y * 12 + (m - 1) + months;
  const yy = Math.floor(total / 12);
  const mm = total % 12;
  return `${String(yy).padStart(4, "0")}-${String(mm + 1).padStart(2, "0")}`;
}
